import { Box, ImageList, Typography } from '@mui/material';
import typography from '../../styles/typography.module.css';
import layout from '../../styles/layout.module.css';
import { useTranslation } from 'react-i18next';

export const FeaturedTechnology = ({ technology }) => {
    const techList = Object.values(technology);
    const { t } = useTranslation();
    return (
        <Box className={layout.subSectionContainer}>
            <Typography className={typography.modelDescriptionSubTitle} style={{ width: '100%' }}>
                {t('model.featured_tech')}:{' '}
            </Typography>
            <ImageList className={layout.containerFullFlexLeft} cols={techList.length}>
                {techList.map((tech) => (
                    // <ImageListItem key={tech.image}>
                    <img
                        key={tech.image}
                        className={typography.techImage}
                        src={`${tech.image}`}
                        alt={tech.name}
                        loading="lazy"
                    />
                    // </ImageListItem>
                ))}
            </ImageList>
        </Box>
    );
};
